export default __webpack_public_path__ + "static/media/addtable.bacaec7b.svg";